import { configureStore } from '@reduxjs/toolkit'

import mobileMenuSlice from './mobile-menu-slice'
import mainSubmenuSlice from './main-submenu-slice'
import contactFloatingSlice from './contact-floating-slice'
import contactFormModalSlice from './contact-form-modal-slice'
import mainSearchTextboxSlice from './main-search-textbox-slice'

export const store = configureStore({
    reducer: {
        mobileMenu: mobileMenuSlice,
        mainSubmenu: mainSubmenuSlice,
        contactFloating: contactFloatingSlice,
        contactFormModal: contactFormModalSlice,
        mainSearchTextbox: mainSearchTextboxSlice,
    }
})

// store.subscribe(() => console.log(store.getState()))

